import React, { useState, useEffect, useMemo } from 'react';
import './style.css';
import { Fade } from "react-awesome-reveal";

const Demographics = () => {
  const [backgroundIndex, setBackgroundIndex] = useState(0);
  const [fadeClass, setFadeClass] = useState('');

  // Initialize background images using useMemo
  const backgroundImages = useMemo(() => {
    return [
      require('../../assets/background-images/ecommerce.jpg'),
      require('../../assets/background-images/electronics.jpg'),
      require('../../assets/background-images/hotel.jpg'),
      require('../../assets/background-images/restuarent.jpg'),
      require('../../assets/background-images/pharmacy.jpg'),
      require('../../assets/background-images/textiles.jpg'),
      require('../../assets/background-images/jewellery.jpg'),
      require('../../assets/background-images/apparel.jpg'),
    ];
  }, []);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
        window.scrollTo({
            top: section.offsetTop,
            behavior: 'smooth' // Make the scrolling smooth
        });
    }
  }

  useEffect(() => {
    const changeBackground = () => {
      setFadeClass('fade-out');
      setTimeout(() => {
        setBackgroundIndex((prevIndex) => (prevIndex + 1) % backgroundImages.length);
        setFadeClass('fade-in');
      }, 500); // Adjust timing as needed
    };
  
    const intervalId = setInterval(changeBackground, 2000); // Change image every 2 seconds
    return () => clearInterval(intervalId); // Cleanup function to clear the interval
  }, [backgroundImages]); // Include backgroundImages in the dependency array
  return (
    <div id="DemoGraphicsSection" className={`demo-graphics-layout ${fadeClass}`} style={{ backgroundImage: `url(${backgroundImages[backgroundIndex]})` }}>
      <div className='blur-container'>
        <div className='main-container'>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>
          <br/>

          <div className="demo-graphics-container">
            <div className="demo-graphics-section1">
              <h1 className="demo-graphics-section-title">Become a BOSS! Unleash Your App!.</h1>
              <br/>
              <br/>
              <Fade cascade damping={0.1}>
                <div className="demo-graphics-section-description">“Craft an unforgettable shopping experience with “BOSS“, Crafting needs No coding“</div>
              </Fade>
              <div className="demo-graphics-action-container">
                <div className="demographics-action-button-1" onClick={() => scrollToSection('bossMagicSection')}>Book a Demo</div>
                <div className="demographics-action-button-2" onClick={() => scrollToSection('pricingSection')}>Create Free App</div>
              </div>
            </div>  
       
            <div className="demo-graphics-section2">
            <div className="demo-grpahics-section-one">Create an E-commerce app for</div>
            <div className="demo-grpahics-section-two">
              {backgroundIndex === 0 && " Bussiness"}
              {backgroundIndex === 1 && " Electronics shop"}
              {backgroundIndex === 2 && " Hotels"}
              {backgroundIndex === 3 && " Restaurant"}
              {backgroundIndex === 4 && " Pharmacy"}
              {backgroundIndex === 5 && " Textiles"}
              {backgroundIndex === 6 && " Jewellery"}
              {backgroundIndex === 7 && " Apparel"}
              </div>

            </div>
          </div> 
        </div>
      </div>
    </div>
  );
}

export default Demographics
